import React, { FC, useEffect, useState } from 'react';
import cn from 'classnames';
import { useLocation } from 'react-router';

import { MessageForm, MessageResult } from 'components/organisms';
import { SwipeTransition } from 'components/molecules';
import useWindowSize from 'hooks/useWindowSize';
import convertBase64ToFile from 'utils/convertBase64ToFile';

import { MessageResultType } from 'queries/types/MessageResultType';
import { MessageFileType, MessageFormType } from 'queries/types/MessageFormType';

import './Message.scss';

const Message: FC = () => {
  const [resultData, setResultData] = useState<MessageResultType | null>(null);
  const [swipeState, setSwipeState] = useState<boolean>(false);
  const [formTypeFile, setFormTypeFile] = useState<boolean>(false);
  const [manualFormData, setManualFormData] = useState<MessageFormType>({
    text: '',
    context: '',
    tones: [],
    keywords: [],
    topics: [],
    output_languages: [],
    outputs_per_tone: 5,
    word_limit: 20,
    creativity_level: 'Balanced',
  });
  const [fileFormData, setFileFormData] = useState<MessageFileType>({
    file: null,
    fileName: '',
    name: '',
  });

  const location = useLocation();
  // eslint-disable-next-line
  const [windowWidth, windowHeight] = useWindowSize();

  const navigationState = location.state || null;

  useEffect(() => {
    if (navigationState) {
      if ('base64_input_file' in navigationState) {
        setTimeout(() => setFormTypeFile(true), 500);
        console.log(convertBase64ToFile(navigationState.base64_input_file));
        setFileFormData({
          file: convertBase64ToFile(navigationState.base64_input_file),
          fileName: navigationState.input_file_name,
          name: navigationState.input_sheet_name,
        });
      } else {
        setManualFormData((prev) => ({ ...prev, ...navigationState }));
      }
    }
  }, [navigationState]);

  useEffect(() => {
    if (resultData) {
      setSwipeState(true);
    }
  }, [resultData]);

  useEffect(() => {
    if (!swipeState && resultData) {
      setTimeout(() => setResultData(null), 2000);
    }
  }, [swipeState]);

  return (
    <section
      className={cn(
        'section section-center message',
        windowHeight >= 780 && !resultData && 'no-scroll',
      )}
      id={'message'}
    >
      <SwipeTransition
        elements={[
          <MessageResult
            key="message-result"
            resultData={resultData}
            setSwipeState={setSwipeState}
          />,
          <MessageForm
            key="message-form"
            fileFormData={fileFormData}
            manualFormData={manualFormData}
            setFileFormData={setFileFormData}
            setResultData={setResultData}
            setManualFormData={setManualFormData}
            formTypeFile={formTypeFile}
            setFormTypeFile={setFormTypeFile}
          />,
        ]}
        hide={true}
        state={swipeState}
        className={cn('message-swipe', swipeState && 'message-swipe-scroll')}
      />
    </section>
  );
};

export default Message;
